// Transaction Id here would be payment_partner_order/paas_id equivalent, ie, id used by 3rd party systems

export type AppRedirectionInfo = {
    paymentMethodType: {
        type: PaymentMethodType;
        cardSubType?: PaymentMethodCardSubType;
        upiSubType?: PaymentMethodUpiSubType;
        walletSubType?: PaymentMethodWalletSubType;
        emiAggregator?: PaymentMethodEMISubType;
    };
    cardRedirect?: CardRedirectionInfo;
    pollingConfiguration?: {
        maxTimeToPollForInMs?: number;
        pollingIntervalInMs?: number;
    };
    walletRedirect?: {
        phonepeRedirect?: {
            sdkRedirect?: PhonePeSDKRedirectInfo;
            webRedirect?: PhonePeWebRedirectInfo;
            pwa?: PhonePePwaRedirectInfo;
        };
        amazonpayRedirect?: AmazonPayRedirectInfo;
        credRedirect?: CredRedirectInfo;
    };
    upiRedirect?: {
        upiIntentRedirect?: UPIIntentRedirectInfo;
        upiCollectRedirect?: UPICollectRedirectInfo;
    };
    emiRedirect?: {
        // this is for juspay powered emi
        juspayEmiRedirect?: {
            redirectionUrl?: string;
            // this key currently has no usecase at client end, added for future usecases acc to contract
            redirectionUrlExpiry?: string;
        };
        // this is for swiggy powered emi
        nativeEmiRedirect?: {
            amount?: string;
            authToken?: string;
            emiCardPaymentType?: string;
            transactionId?: string;
        };
    };
    inappUpiRedirect?: InAppUPIRedirectInfo;
    nbRedirect?: NBRedirectInfo;
};

export enum PaymentMethodType {
    TYPE_CARD = "TYPE_CARD",
    TYPE_UPI = "TYPE_UPI",
    TYPE_WALLET = "TYPE_WALLET",
    TYPE_BNPL = "TYPE_BNPL",
    TYPE_NB = "TYPE_NB",
    TYPE_SWIGGY_MONEY = "TYPE_SWIGGY_MONEY",
    TYPE_INAPP_UPI = "TYPE_INAPP_UPI",
    // To be deprecated
    TYPE_CASH = "TYPE_CASH",
    TYPE_EMI = "TYPE_EMI",
}

export enum PaymentMethodCardSubType {
    CARD_TYPE_CREDIT_CARD = "CARD_TYPE_CREDIT_CARD",
    CARD_TYPE_DEBIT_CARD = "CARD_TYPE_DEBIT_CARD",
    CARD_TYPE_PREPAID_CARD = "CARD_TYPE_PREPAID_CARD",
    CARD_TYPE_FOOD_CARD = "CARD_TYPE_FOOD_CARD",
}

export enum PaymentMethodUpiSubType {
    UPI_TYPE_COLLECT = "UPI_TYPE_COLLECT",
    UPI_TYPE_INTENT = "UPI_TYPE_INTENT",
}

export enum PaymentMethodWalletSubType {
    WALLET_TYPE_PAYTM = "WALLET_TYPE_PAYTM",
    WALLET_TYPE_FREECHARGE = "WALLET_TYPE_FREECHARGE",
    WALLET_TYPE_AMAZONPAY = "WALLET_TYPE_AMAZONPAY",
    WALLET_TYPE_MOBIKWIK = "WALLET_TYPE_MOBIKWIK",
    WALLET_TYPE_PHONE_PE = "WALLET_TYPE_PHONE_PE",
    WALLET_TYPE_CRED = "WALLET_TYPE_CRED",
}
export enum PaymentMethodEMISubType {
    EMI_SUB_TYPE = "EMI_AGGREGATOR_THIRD_PARTY_JUSPAY",
}

// This information is required to initiate transaction in Phonepe SDK client.
interface PhonePeSDKRedirectInfo {
    base64Body: string;
    checksum: string;
    apiEndPoint: string;
    transactionId: string;
    s2sCallBackUrl: string;
}

// This information is required to initiate phoneope web transaction.
interface PhonePeWebRedirectInfo {
    paymentUri: string;
}

// This information is required to initiate phoneope pwa transaction.
interface PhonePePwaRedirectInfo {
    reservationId: string;
}

export interface CardRedirectionInfo {
    authToken: string;
    cardPaymentType: string;
    transactionId: string;
    amount?: string;
    tokenRequester?: string;
    tokenServiceProvider?: string;
    tokenInfo?: {
        juspayInfo?: JuspayMetaDataInfo;
        payUinfo?: JuspayMetaDataInfo; // payUinfo will be added here, Will be used later once we have redirection payu flow in picture
    };
}

export interface UPIIntentRedirectInfo {
    upiIntentUrl: string;
    upiIntentConfirmTimeInMs: number;
    transactionId: string;
}

interface InAppUPIRedirectInfo {
    amount: string;
    transactionId: string;
}

interface NBRedirectInfo {
    authToken: string;
    transactionId: string;
}

// This information is required to complete upi collect transaction. In case of upi collect client polls payment backend api for transaction
// status but if transaction does not reach to terminate state within passed time than client send confirm order irrespective of transaction status.
export interface UPICollectRedirectInfo {
    upiIntentConfirmTimeInMs: number;
    transactionId: string;
}

// This information is required to initiate transaction in Amazon SDK client and web client.
interface AmazonPayRedirectInfo {
    /*
    encryptedPayload is a JSON.stringifyied version of below object
    {
        paymentRedirectUrl?: string;
        payload?: string;
        key?: string;
        iv?: string;
    }
    Present in old SDK/web flow, absent in new SDK flow.
    */
    encryptedPayload?: string;
    // Direct payment URI used in new APay SDK flow (replaces encryptedPayload)
    paymentUri?: string;
    transactionId: string;
}

interface CredRedirectInfo {
    authToken: string;
    transactionId: string;
    credConfirmTimeInMs: number;
}

export interface JuspayMetaDataInfo {
    temporaryToken?: string;
    providerReferenceId?: string;
    providerCategory?: string;
    requesterId?: string;
    tokenType?: string;
    provider?: string;
}
